import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import classes from './Filters.scss';
import { connect } from "react-redux";
import Button from '../UI/Button/Button';

import FilterStopover from './FilterStopover/FilterStopover';
import FilterLayover from './FilterLayover/FilterLayover';
import FilterDeparture from './FilterDeparture/FilterDeparture';
import FilterReturn from './FilterReturn/FilterReturn';
import FilterAirlines from './FilterAirlines/FilterAirlines';

import HeadingH4 from '../UI/Headings/HeadingH4/HeadingH4';
import { toggleDesktopFilters, resetFilters, applyFilters, closeSidebar, switchHeaderView } from '../../store/actions/index';

class Filters extends Component {

    state = {
        rotate: false,
        isDeparture: true
    }

    resetFilters = () => {
        this.setState(prevState => {
            return { rotate: !prevState.rotate }
        }, () => {
            setTimeout(() => {
                this.setState(prevState => {
                    return { rotate: !prevState.rotate }
                });
            }, 1000);
        });
        this.props.onResetFilters();
    }

    toggleFilterHandler = (flightType) => {
        if(flightType === "departure") {
            this.setState({
                isDeparture: true
            })
        } else {
            this.setState({
                isDeparture: false
            })
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className={`u-flex u-relative u-backgroundColorWhite u-borderBottomNormal f-row phone-f-column`}>
                    <div className={`f-1 pl-4 pr-4 pt-5 pb-5 phone-pt-3 phone-pb-3 u-borderRightNormal`}>
                        <div className={`mb-6`}>
                            <div className="mb-3">
                                <HeadingH4 size={11} weight="Medium" color="Dark">
                                    <span className="u-textUppercase">Stopovers:</span>
                                </HeadingH4>
                            </div>
                            <FilterStopover />
                        </div>                        
                        <div>
                            <div className="mb-3">
                                <HeadingH4 size={11} weight="Medium" color="Dark">
                                    <span className="u-textUppercase">Layover Time:</span>
                                </HeadingH4>
                            </div>
                            <FilterLayover />
                        </div>
                    </div>
                    <div className={`f-1 pl-4 pr-4 pt-5 pb-5 phone-pt-3 phone-pb-3 u-borderRightNormal`}>
                        <div className={`mb-6 phone-mb-0`}>
                            <div className="mb-3">
                                <HeadingH4 size={11} weight="Medium" color="Dark">
                                    <span className="u-textUppercase">Departure:</span>
                                </HeadingH4>
                            </div>
                            <FilterDeparture />
                        </div>    
                        {this.props.flightType === "R" ? (
                            <div>
                                <div className="mb-3">
                                    <HeadingH4 size={11} weight="Medium" color="Dark">
                                        <span className="u-textUppercase">Return:</span>
                                    </HeadingH4>
                                </div>
                                <FilterReturn />
                            </div>
                        ) : null}
                    </div>
                    <div className={`f-1 pl-4 pr-4 pt-5 pb-5 phone-pt-3 phone-pb-3 u-height100Percent`}>
                        <div className="mb-3">
                            <HeadingH4 size={11} weight="Medium" color="Dark">
                                <span className="u-textUppercase">Airlines:</span>
                            </HeadingH4>
                        </div>
                        <FilterAirlines/>
                    </div>
                </div>
                <div className={`u-flex justify-content-between align-items-center pt-2 pb-2 pl-6 pr-6 u-backgroundColorWhite u-phone-sticky u-phone-bottom0 u-phone-borderBottomNormal u-phone-borderTopNormal`}>
                    <div>
                        <span className={`u-textColorPrimary u-cursorPointer`} onClick={this.resetFilters}>
                            <span className={[classes.ResetButton, this.state.rotate ? classes.ResetButtonActive : null].join(' ')}>
                                <FontAwesomeIcon icon="redo" color="#3E72F7" size="sm" />
                            </span>
                            <span className={`ml-1`}>Clear All</span>
                        </span>
                    </div>
                    <div className={`u-flex align-items-center`}>
                        <div className={`u-cursorPointer mr-6 u-phoneHide`} onClick={() => this.props.onToggleDesktopFilters()}>
                            <span className={`u-textTransformUppercase u-textColorPrimary u-fontSize13`}>Cancel</span>
                        </div>
                        <div className={`mr-6 u-phoneShow`}>
                            <span onClick={() => this.props.onSwitchHeaderView('calendar')} className={`u-textTransformUppercase u-textColorPrimary u-fontSize13`}>Cancel</span>
                        </div>
                        <div className={`u-phoneHide`}>
                            <Button theme='Primary' type='Apply' onClick={() => {
                                this.props.onCloseSidebar();
                                this.props.onApplyFilters();
                                this.props.onToggleDesktopFilters();
                                }}>Apply</Button>
                        </div>
                        <div className={`u-phoneShow`}>
                            <Button theme='Primary' type='Apply' onClick={() => {
                            this.props.onCloseSidebar();
                            this.props.onApplyFilters();
                            this.props.onSwitchHeaderView('calendar');
                            }}>Apply</Button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        mobileFiltersToggle: state.ui.mobileFiltersToggle,
        flightType: state.flights.flightType
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onResetFilters: () => dispatch(resetFilters()),
        onApplyFilters: () => dispatch(applyFilters()),
        onToggleDesktopFilters: () => dispatch(toggleDesktopFilters()),
        onCloseSidebar: () => dispatch(closeSidebar()),
        onSwitchHeaderView: (view) => dispatch(switchHeaderView(view))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Filters);


// WEBPACK FOOTER //
// ./src/components/Filters/Filters.js